// filepath: c:\Users\greg\regulator\express\analysis-app\src\components\dashboard\charts\RadialGauge.jsx

import BaseChart from './BaseChart'
import PropTypes from 'prop-types'

function RadialGauge({ 
  value = 0, 
  max = 100, 
  min = 0,
  title = 'Gauge', 
  height = 250,
  color = '#007bff',
  trackColor = '#e9ecef',
  showLabels = true,
  unit = '',
  loading = false,
  error = null,
  ...props 
}) {
  // Calculate percentage for the gauge
  const percentage = Math.min(Math.max(((value - min) / (max - min)) * 100, 0), 100)

  // Radial gauge specific options
  const gaugeOptions = {
    chart: {
      type: 'radialBar',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 225,
        hollow: {
          margin: 0,
          size: '70%',
          background: '#fff',
          image: undefined,
          position: 'front',
          dropShadow: {
            enabled: true,
            top: 3,
            left: 0,
            blur: 4,
            opacity: 0.24,
          },
        },
        track: {
          background: trackColor,
          strokeWidth: '67%',
          margin: 0,
          dropShadow: {
            enabled: true,
            top: -3,
            left: 0,
            blur: 4,
            opacity: 0.35,
          },
        },
        dataLabels: {
          show: showLabels,
          name: {
            offsetY: -10,
            show: true,
            color: '#888',
            fontSize: '13px',
          },
          value: {
            formatter(val) {
              return parseInt(val, 10).toString()
            },
            color: '#111',
            fontSize: '30px',
            show: true,
            offsetY: 16,
          },
        },
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        type: 'horizontal',
        shadeIntensity: 0.5,
        gradientToColors: [color],
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    colors: [color],
    labels: [title],
    legend: {
      show: false,
    },
  }

  // Prepare series data - convert actual value to percentage for display
  const series = [percentage]

  // Custom labels showing actual values
  const customLabels = showLabels ? {
    ...gaugeOptions,
    plotOptions: {
      ...gaugeOptions.plotOptions,
      radialBar: {
        ...gaugeOptions.plotOptions.radialBar,
        dataLabels: {
          ...gaugeOptions.plotOptions.radialBar.dataLabels,
          value: {
            ...gaugeOptions.plotOptions.radialBar.dataLabels.value,
            formatter() {
              return `${value}${unit}`
            },
          },
        },
      },
    },
  } : gaugeOptions

  return (
    <div className="radial-gauge-container">
      <BaseChart
        series={series}
        options={customLabels}
        type="radialBar"
        height={height}
        loading={loading}
        error={error}
        fallbackText="No gauge data available"
        {...props}
      />
      {showLabels && (
        <div className="gauge-info text-center mt-2">
          <small className="text-muted">
            Range: {min}{unit} - {max}{unit}
          </small>
        </div>
      )}
    </div>
  )
}

RadialGauge.propTypes = {
  value: PropTypes.number,
  max: PropTypes.number,
  min: PropTypes.number,
  title: PropTypes.string,
  height: PropTypes.number,
  color: PropTypes.string,
  trackColor: PropTypes.string,
  showLabels: PropTypes.bool,
  unit: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default RadialGauge
